import styles from "./SchoolTrainingPlansRow.module.styl";
import { exact, number, shape, string } from "prop-types";
import React from "react";
import Chart from "react-apexcharts";
import { chartOptions, smallChartWidth } from "utils/chart/chartOptions";
import { percentageLevels } from "utils/indicator/indicatorSettings";

export default function SchoolTrainingPlansRow({ schoolTrainingPlan }) {
    const indicatorStyle = percentageLevels.indicatorColor(
        schoolTrainingPlan.trainingPlan.trainingsWithFilledPlanPercentage,
    );
    const options = chartOptions(indicatorStyle);
    const series = [schoolTrainingPlan.trainingPlan.trainingsWithFilledPlanPercentage];

    const sportTrainingInfoString =
        schoolTrainingPlan.sportTrainingLevel != null
            ? schoolTrainingPlan.sportTrainingYear == null ||
              schoolTrainingPlan.sportTrainingYear === 0
                ? `${schoolTrainingPlan.sportTrainingLevel}`
                : `${schoolTrainingPlan.sportTrainingLevel}-${schoolTrainingPlan.sportTrainingYear}`
            : `-`;

    return (
        <div className={styles.row}>
            <div className={styles.groupCode}>{schoolTrainingPlan.groupCode}</div>
            <div className={styles.sportType}>{schoolTrainingPlan.sportType}</div>
            <div className={styles.sportTraining}>{sportTrainingInfoString}</div>
            <div className={styles.primaryCoachName}>
                {schoolTrainingPlan.primaryCoachName.lastNameAndInitials}
            </div>
            <div className={styles.secondaryCoachName}>
                {schoolTrainingPlan.secondaryCoachName != null
                    ? schoolTrainingPlan.secondaryCoachName.lastNameAndInitials
                    : "-"}
            </div>
            <div className={styles.trainingPlanInfo}>
                {schoolTrainingPlan.trainingPlan.trainingsWithFilledPlanCount}/
                {schoolTrainingPlan.trainingPlan.trainingsCount}
            </div>
            <div className={styles.chart}>
                <Chart options={options} series={series} type="radialBar" width={smallChartWidth} />
            </div>
        </div>
    );
}

SchoolTrainingPlansRow.propTypes = {
    schoolTrainingPlan: shape({
        groupId: number,
        groupCode: string,
        sportType: string,
        sportTrainingLevel: string,
        sportTrainingYear: number,
        primaryCoachName: exact({
            lastName: string.isRequired,
            firstName: string.isRequired,
            middleName: string,
            shortName: string.isRequired,
            fullName: string.isRequired,
            officialShortName: string.isRequired,
            officialFullName: string.isRequired,
            lastNameAndInitials: string.isRequired,
            firstNameAndMiddleName: string.isRequired,
        }),
        secondaryCoachName: exact({
            lastName: string.isRequired,
            firstName: string.isRequired,
            middleName: string,
            shortName: string.isRequired,
            fullName: string.isRequired,
            officialShortName: string.isRequired,
            officialFullName: string.isRequired,
            lastNameAndInitials: string.isRequired,
            firstNameAndMiddleName: string.isRequired,
        }),
        trainingPlan: exact({
            trainingsWithFilledPlanCount: number.isRequired,
            trainingsCount: number.isRequired,
            trainingsWithFilledPlanPercentage: number.isRequired,
        }),
    }),
};
